import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { Fragment, memo, useState } from "react";
import { useNotify, Button, useMutation } from "react-admin";
import { StyledButton } from "../../../components/ListShowButton";

interface DeleteCommercialDocumentButtonProps {
  mbcRef: string;
  type: "mbc" | "id";
}

const DeleteCommercialDocumentButton = ({
  mbcRef,
  type,
}: DeleteCommercialDocumentButtonProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const notify = useNotify();

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
    cancelButton: {
      backgroundColor: "#eeeeee",
      color: "black",
    },
  });

  const classes = useStyles();

  const [handleDeleteUnpostedCommercialDocument, { loading }] = useMutation(
    {
      type: "delete",
      resource: `commercialDocuments${type === "mbc" ? "/mbc" : ""}`,
      payload: { id: mbcRef },
    },
    {
      onSuccess: () => {
        notify(`Successfully delete the Commercial Document.`, "info");
        window.location.reload();
      },
      onFailure: (error) => {
        notify(
          `Failed delete the Commercial Document, error: ${error.message}`,
          "warning"
        );
      },
    }
  );

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <StyledButton
        variant="outlined"
        onClick={handleOpenDialog}
        style={{ color: "#f44336", borderColor: "#f44336" }}
      >
        Delete
      </StyledButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">Delete Confirmation</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure want to delete this commercial document {mbcRef} ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDeleteUnpostedCommercialDocument}
            color="primary"
            undoable={false}
            label={loading ? `Loading...` : `Yes`}
            disabled={loading}
          />
          <Button
            onClick={handleClose}
            color="secondary"
            label="Cancel"
            className={classes.cancelButton}
            disabled={loading}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default memo(DeleteCommercialDocumentButton);
